/* globals Wee, moment */

Wee.fn.make('validate', {
	config: {
		allowWeeObject: true,
		allowDomObject: true,
		allowSelector: true
	},
	param: function(key, val) {
		this.config[key] = val;

		return this;
	},
	run: function(validate) {
		var results = [],
		setIdx;

		for (setIdx in validate) {
			var set = validate[setIdx],
				value = set[0],
				result = this.check(value, set[1]);

			if (result.length) {
				results.push([value, result[0]]);
			}
		}

		return results;
	},
	check: function(value, rules) {
		var rulesSet = [],
			rulesPairs = [],
			required = false,
			orRule = false,
			results = [],
			orCond,
			result,
			idx;

		// Test value for wee object, dom object, js selector, or just plain string
		if (typeof value === 'object') {
			if (this.config.allowWeeObject && typeof value.sel === 'string') {
				value = value.val();
			} else if (this.config.allowDomObject && typeof value.sel === 'undefined') {
				value = $(value).val();
			}
		} else if (rules.indexOf('hasCount') !== -1) {
			value = $(value);
		} else if (this.config.allowSelector && /^(#|\.|ref:)+/.test(value) && $(value).length) {
			value = $(value).val();
		}

		if (typeof rules === 'string') {
			// Parse out the rules, separating groups, rules, and parameters.
			rulesPairs = rules.match(/\([^)]*\)/g);
			rulesSet = rules.replace(/\([^)]*\)/g, '')
				.replace(/^(\|+)?/g, '')
				.replace(/(\|+)?$/g, '')
				.split('|');

			for (idx in rulesSet) {
				if (rulesSet[idx] === 'required' && ! orCond) {
					required = true;
				} else if (rulesSet[idx].substr(0, 3) === 'or:') {
					orRule = true;
					required = false;
					orCond = rulesSet[idx];
				}
			}
		}

		if (required || orRule || value.length) {
			results = this.runSet(value, rulesSet);

			for (idx in rulesPairs) {
				rulesSet = rulesPairs[idx].replace(/[()]?/g, '').split('|');
				result = this.runSet(value, rulesSet);

				if (result.length === rulesSet.length) {
					results = results.concat(result);
				}
			}

			// Catch cases that pass an Or: rule but might fail another rule
			if (orRule && ! value.length && results.length === 1 && results[0] !== orCond) {
				results = [];
			}
		}

		return results;
	},
	runSet: function(value, rulesSet) {
		var results = [],
			result,
			idx;

		for (idx in rulesSet) {
			result = this.runRule(value, rulesSet[idx].split(':'));

			if (result.length) {
				results.push(result);
			}
		}

		return results;
	},
	runRule: function(value, rulePair) {
		var rule = rulePair[0],
			params = [
				value
			],
			result;

		if (rulePair.length === 2) {
			params.push(rulePair[1]);
		}

		result = this.$private.rules[rule].apply(this, params);

		if (! result) {
			return rule;
		}

		return '';
	}
}, {
	rules: {
		after: function(value, set) {
			var $startEl = $(set),
				startDate = ($startEl.length && $startEl.val().length) ? moment($startEl.val()) : false,
				endDate = moment(value);

			if (! startDate || endDate.isAfter(startDate)) {
				return true;
			}

			return false;
		},
		before: function(value, set) {
			var $endEl = $(set),
				startDate = moment(value),
				endDate = ($endEl.length && $endEl.val().length) ? moment($endEl.val()) : false;

			if (! endDate || startDate.isBefore(endDate)) {
				return true;
			}

			return false;
		},
		currency: function(value) {
			return /^\$?[\d,]+$/.test(value);
		},
		date: function(value) {
			return moment(value).isValid();
		},
		email: function(value) {
			return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
		},
		in: function(value, set) {
			return set.split(',').indexOf(value) !== -1;
		},
		match: function(value, set) {
			var check = new RegExp('^' + set + '$', 'i');

			return check.test(value);
		},
		numeric: function(value) {
			return /^[\d]+\.?[\d]+$/.test(value);
		},
		or: function(value, set) {
			var $el = $(set),
				otherVal = $el.length ? $el.val() : '';

			return value.length || otherVal.length;
		},
		phone: function(value) {
			var len = value.replace(/[^\d]*/g, '').length;

			// Allow standard 7-digit; with area code; with country code; with extension
			return len === 7 || len === 10 || len >= 11;
		},
		required: function(value) {
			return typeof value !== 'undefined' && value.length !== 0;
		},
		hasCount: function(value, check) {
			if (check === null) {
				check = 1;
			} else {
				check = parseInt(check);
			}

			return typeof value !== 'undefined' && value.length >= check;
		},
		confirm: function(value, selector) {
			return value === $('.' + selector).val();
		},
		hasCountExact: function(value, check) {
			if (check === null) {
				check = 1;
			} else {
				check = parseInt(check);
			}

			return typeof value !== 'undefined' && value.length === check;
		}
	}
});
